module.exports = __webpack_public_path__ + "static/media/6.6028bac0.svg";